import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

import { AuthService } from '@mark/common-lib/services';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { ISnackBarData, SnackBarComponent } from '@recovery/app/shared/components/snack-bar/snack-bar.component';
import { map, switchMap, tap } from 'rxjs';

import { ErrorService } from '../../services/error.service';
import { TokenService } from '../../services/token.service';
import * as actions from '../actions/setting.actions';
import { IAppState } from '../states/app.state';
@Injectable()
export class SettingEffects {
  signUp$ = createEffect(() =>
    this._actions$.pipe(
      ofType(actions.SIGN_UP_COMMAND),
      switchMap(() =>
        this._authService.login({ lang: 'en' }).pipe(
          tap(({ status, error }) => {
            switch (status) {
              case 'success':
                break;
              case 'error':
                this._snackBar.openFromComponent(SnackBarComponent, {
                  data: {
                    text: error ? error : 'Oops! Something went wrong. Please try again.',
                    closeButton: true,
                    icon: { name: 'info' },
                    action: 'error',
                  } as ISnackBarData,
                  duration: 5000,
                  verticalPosition: 'top',
                  horizontalPosition: 'center',
                  panelClass: ['mark-snackbar', 'error'],
                });
                break;
              default:
                break;
            }
          }),
          map(({ status }) => actions.SIGN_UP_SUCCESS({ valid: status === 'success' })),
        ),
      ),
    ),
  );

  signUpSuccess$ = createEffect(() =>
    this._actions$.pipe(
      ofType(actions.SIGN_UP_SUCCESS),
      map(() => actions.CHECK_USER_COMMAND()),
    ),
  );

  constructor(
    private readonly _store$: Store<IAppState>,
    private readonly _actions$: Actions,
    private readonly _tokenService: TokenService,
    private readonly _errorService: ErrorService,
    private readonly _snackBar: MatSnackBar,
    private readonly _authService: AuthService,
  ) {}
}
